import React from 'react';
import { useQuery } from 'react-query';
import { getDivisions } from './glossary.api';
import { handleError } from '../../common/utils/util.errors';
import { LinearProgress } from '@mui/material';
import keys from '../../common/react-query/data-keys';
import { ONE_DAY_MS } from '../../common/constants/general';
import SelectDivisionFromGiven from './SelectDivisionFromGiven';

interface SelectDivisionProps {
  selectedDivision: string | null;
  setSelectedDivision: (newVal: string | null) => void;
}

const SelectDivision: React.FC<SelectDivisionProps> = ({ selectedDivision, setSelectedDivision }) => {
  // Divisions rarely change; avoid refetching on every mount.
  const { data: divisions, isLoading, isError, error } = useQuery(keys.divisions, getDivisions, { staleTime: ONE_DAY_MS });

  if (isLoading) return <LinearProgress />;
  if (isError) handleError(error);
  if (!divisions) return null;

  return (
    <SelectDivisionFromGiven
      label='Division'
      selectedDivision={selectedDivision}
      setSelectedDivision={setSelectedDivision}
      divisions={divisions}
    />
  );
};

export default SelectDivision;
